import { render, staticRenderFns } from "./RvVideo.vue?vue&type=template&id=a8c8c2b6&"
import script from "./RvVideo.vue?vue&type=script&lang=js&"
export * from "./RvVideo.vue?vue&type=script&lang=js&"
import style0 from "./RvVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports